/* @flow */

import * as React from 'react';

import type {ActionMeta, SelectBaseProps} from 'react-select';

import {colors} from '../colors';

import {SelectPickerGeneric} from '../select-picker-generic';

import './select-two-line-icon.css';

type TwoLineOptionWithIcon = {
    value: string,
    label: string,
    sublabel: string,
    icon: React.ComponentType<*>,
};

export type Props = {|
    ...$Exact<SelectBaseProps>,
    value?: ?TwoLineOptionWithIcon,
    options: TwoLineOptionWithIcon[],
    onChange: (value: TwoLineOptionWithIcon, action: ActionMeta) => void,
|};

export function SelectTwoLineIcon(props: Props) {
    // isMulti and isClearable throw a flow error on Select Picker Generic
    // eslint-disable-next-line no-unused-vars
    const {isMulti, isClearable, onBlur, ...restProps} = props;

    const [selectedValue, setSelectedValue] = React.useState<?TwoLineOptionWithIcon>(
        props.value ? props.value : undefined
    );

    function formatOptionLabel(option: TwoLineOptionWithIcon) {
        const Icon = option.icon;

        return (
            <div
                styleName={
                    option === selectedValue
                        ? 'select-two-line-icon-option--selected'
                        : 'select-two-line-icon-option'
                }
            >
                {Icon ? (
                    <div styleName='icon-container'>
                        <Icon size={19} />
                    </div>
                ) : (
                    undefined
                )}
                <div styleName='label-container'>
                    <div styleName='label'>{option.label}</div>
                    <div styleName='sublabel'>{option.sublabel}</div>
                </div>
            </div>
        );
    }

    const styles = {
        control: (base, state) => ({
            ...base,
            '&:hover': {
                borderColor: colors.greyLt,
            },
            borderColor: state.isFocused ? colors.greyLt : colors.offWhiteDk,
            borderRadius: 3,
            border: state.isFocused
                ? `2px solid ${colors.greyLt}`
                : `2px solid ${colors.offWhiteDk}`,
            boxShadow: 'none',
            top: 2,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            height: '38px',
            minHeight: '38px',
        }),
        indicatorSeparator: (base) => ({
            ...base,
            display: true,
        }),
    };

    return (
        <div styleName='select-two-line-icon'>
            <SelectPickerGeneric
                {...restProps}
                onChange={(option, action) => {
                    setSelectedValue(option);
                    props.onChange(option, action);
                }}
                options={props.options}
                styles={styles}
                formatOptionLabel={formatOptionLabel}
                isSearchable={false}
                // Who can explain it, who can tell why. Somehow, this
                // works. The onBlur must be explicitly set here.
                onBlur={onBlur}
            />
        </div>
    );
}
